import styled from 'styled-components'

interface Input {
  error: boolean
  isActive: boolean
}

export const InputStyle = styled.input<Input>`
  width: 24px;
  height: 24px;
  border: ${props => (props.isActive ? `1px solid  ${props.theme.colors.color1f6ecd}` : `1px solid transparent`)};
  border-radius: 4px;

  @media (max-width: 300px) {
    margin: 0 2px;
  }
  color: ${props => (props.isActive ? props.theme.colors.color1f6ecd : props.theme.colors.color5a6a7e)};
  text-align: center;
  font-family: 'Inter';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 100% */
  cursor: ${props => (props.isActive ? 'inherit' : 'pointer')};

  &:hover {
    border: 1px solid ${props => (props.isActive ? props.theme.colors.color1f6ecd : props.theme.colors.color5a6a7e)};
  }
`
